export default __webpack_public_path__ + "static/media/cupomDescontoBrasilpassagens.0961d4b5.webp";